export interface IFontValue {
  theme?: string;
  family?: string;
  size?: number;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  cssVariableName?: string;
}

export interface FontPickerValue {
  font: string;
  textDecoration?: string;
}

export const UNDERLINE_DEFINITION = 'underline';

export function getFontFamiliesFromFonts(fonts: string[]) {
  return fonts
    .map((font) => parseFontString({ font }).family)
    .filter(Boolean) as string[];
}

export function parseFontString(fontPickerValue?: FontPickerValue) {
  const font: IFontValue = {
    family: undefined,
    size: undefined,
  };

  if (fontPickerValue?.font) {
    const { variableName, fallbackValue } = extractFontVar(
      fontPickerValue.font,
    );
    font.cssVariableName = variableName;
    const parts = fallbackValue.match(/(?:(["']).*?\1|\S)+/g) || [];

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];

      switch (part) {
        case 'bold':
          font.bold = true;
          break;
        case 'italic':
          font.italic = true;
          break;
        default:
          if (part?.endsWith('px')) {
            font.size = parseInt(part, 10);
          } else if (i === parts.length - 1) {
            font.family = part;
          } else {
            font.family = (font.family || '') + ' ' + part;
          }
      }
    }
  }
  if (fontPickerValue?.textDecoration) {
    font.underline = fontPickerValue.textDecoration === UNDERLINE_DEFINITION;
  }
  // since we wrap it with "" in the font string, we need to remove it
  font.family = font.family?.trim().replace(/['"]+/g, '');

  return font;
}

function extractFontVar(fontString: string) {
  const trimmedFont = fontString.trim();
  const match = trimmedFont.match(/var\((--[\w-]+),\s*(.+)\)/);

  if (match) {
    return {
      variableName: match[1],
      fallbackValue: match[2]?.trim() ?? '',
    };
  } else {
    return {
      variableName: undefined,
      fallbackValue: trimmedFont,
    };
  }
}
